import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { Tabs, Card, Typography } from "antd";
import MainCard from '@/components/MainCard';
import BatchProcessApproval from "./BatchProcessApproval";
import BatchRecipeApproval from "./BatchRecipeApproval";
import RecipeViewApproval from "./RecipeViewApproval";
import InfoComponent from '@/components/Info';
import { accessControlUtils } from '@/components/AccessControlUtils';
import { useDispatch, useSelector } from "react-redux";
import ReusableSearchInput from '@/components/ReusableSearch';
import { useTranslation } from "react-i18next";
import { useTheme } from '@/App';
import { defaultColors } from '@/themes/antd-theme';
import Icons from '@/components/third-party/Icons';

const { Title } = Typography;

function Approvals() {
  const [user_access_data, set_user_access_data] = useState([]);

  useEffect(() => {
    try {
      const data = localStorage.getItem("user_access_data");
      if (data && data !== "undefined" && data !== "null") {
        set_user_access_data(JSON.parse(data));
      }
    } catch (error) {
      console.error("Error parsing user_access_data from localStorage:", error);
      localStorage.removeItem("user_access_data");
    }
  }, []);

  const [tab_value, set_tab_value] = useState("1");
  const selectedModule = useSelector((state) => state.moduleView) === "prod";
  const [searchvalue, setSearchvalue] = useState("");
  const { t } = useTranslation();
  const { isDark } = useTheme();

  // Dark mode colors
  const textColor = isDark ? '#ffffff' : '#1f2937';

  return (
    <div
      className="p-2.5"
      style={{ backgroundColor: isDark ? defaultColors.palette.gray[900] : '#f9fafb' }}
    >
    <Card
    className="border border-gray-300 shadow-md approvals-card"
      bordered={false}
      style={{ backgroundColor: isDark ? defaultColors.palette.gray[800] : '#ffffff', minHeight: 'calc(100vh - 120px)', marginTop: 12 }}
      styles={{ body: { paddingTop: 8, paddingBottom: 12 } }}
      title={
        <div className="flex items-center gap-2">
          <Icons.CheckCircle className="text-blue-600" size={24} />
          <Title
            level={4}
            style={{
              color: textColor,
              margin: 0,
              padding: 0,
            }}
          >
            {t('BMR Approvals')}
          </Title>
        </div>
      }
      extra={
        <ReusableSearchInput
          placeholder="Search here..."
          width={250}
          onSearch={(value) => setSearchvalue(value)}
          onChange={(e) => setSearchvalue(e.target.value)}
        />
      }
    >
      {/* Trim the default AntD tab-nav margin so the table sits close to the
          tabs (minimum top space in every tab). */}
      <style>{`
        .approvals-card .ant-tabs-nav { margin-bottom: 8px; }
        .approvals-card .ant-tabs-content-holder { padding-top: 0; }
      `}</style>
      <Tabs
        size="large"
        onChange={(key) => {
          set_tab_value(key);
        }}
        tabBarExtraContent={
          <div className="flex items-center gap-2">
            {/* Column-config button for the ACTIVE tab renders here (portal
                target), so it sits on the tab-bar line to the LEFT of the info
                icon. Each child portals its config button into #approval-col-cfg
                only when it is the active tab. */}
            <div id="approval-col-cfg" className="flex items-center" />
            <InfoComponent
              infoShow={true}
              infoText={`view ${selectedModule ? "MBMR" : "MBPR"}}`}
            />
          </div>
        }
        items={[
          ...(accessControlUtils("BMR Approval")?.read_access
            ? [
                {
                  key: "1",
                  label: `View ${selectedModule ? "BMR" : "BPR"}`,
                  children: (
                    <RecipeViewApproval
                      searchvalue={searchvalue}
                      isActiveTab={tab_value === "1"}
                    />
                  ),
                },
              ]
            : []),
          ...(accessControlUtils("BMR Approval")?.update_access
            ? [
                {
                  key: "2",
                  label: `${selectedModule ? "BMR" : "BPR"} Process Approval`,
                  children: (
                    <BatchProcessApproval
                      searchvalue={searchvalue}
                      isActiveTab={tab_value === "2"}
                    />
                  ),
                },
              ]
            : []),
          ...(accessControlUtils("BMR Approval")?.update_access
            ? [
                {
                  key: "3",
                  label: `${selectedModule ? "BMR" : "BPR"} Approval`,
                  children: (
                    <BatchRecipeApproval
                      searchvalue={searchvalue}
                      isActiveTab={tab_value === "3"}
                    />
                  ),
                },
              ]
            : []),
        ]}
      />
    </Card>
    </div>
  );
}

export default Approvals;
